<template>
  <div>
    <van-cell border style="border-bottom: 1px solid #D7D7D7;">
      <div slot="title">
        <div class="transfbox">
          <div>接送机信息</div>
          <div class="trans_fillin" @click="fillshow()">{{ filltitle ? "取消用车" : '填写用车信息' }}</div>
        </div>
      </div>
    </van-cell>
    <!-- 下面tab分栏 -->
    <van-cell v-if="filltitle">
      <van-tabs v-model="active" type="card">
        <!-- 接机 -->
        <van-tab title="接机" name="0">
          <van-row type="flex" class="input_margin">
            <van-col span="14" @click="cityselect('出发地')"> 
              出发地：
              <input type="text" readonly v-model="carpick.departure_place" placeholder="航班号" class="input_long">
            </van-col>
            <van-col span="10"> 
              航站楼 <input type="text" v-model="carpick.terminal" placeholder="航班号" class="input_short">
            </van-col>
          </van-row>
          <van-row type="flex" class="input_margin">
            <van-col @click="cityselect('目的地')"> 
              目的地： <input type="text" readonly v-model="carpick.toLocationName" placeholder="请输入目的地" class="input_long">
            </van-col>
          </van-row>
          <van-row type="flex" class="input_margin">
            <van-col>
              <!-- @click="$refs.picker.toggle()" -->
              用车时间：<input type="text" v-model="carpick.useTime" readonly placeholder="请选择用车时间" class="input_short_bott">
            </van-col>
          </van-row>
          <van-row type="flex" class="input_margin">
            <van-col span="14"> 
              选择车型:<input @click="Selectcar()" type="text" readonly v-model="carpickmodels.vehicleTypeName" placeholder="请选择车型" class="input_long">
            </van-col>
            <van-col span="10" style="display: flex;"> 
              车数量:
              <!-- <input v-model="carpick.carnumber" @input="carvehicles(carpick.carnumber)"   type="text" placeholder="车数量" class="input_short"> -->
              <van-stepper v-model="carpick.carnumber" :disable-plus=carnumbershow(carpick.carnumber) @change="carvehicles(carpick.carnumber)" button-size="22" />
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="送机" name="1">
          <van-row type="flex" class="input_margin">
            <van-col @click="cityselect('出发地')"> 
              出发地： <input v-model="cardrop.fromLocationName" readonly type="text" placeholder="请输入出发地" class="input_long">
            </van-col>
          </van-row>
          <van-row type="flex" class="input_margin" >
            <van-col span="14" @click="cityselect('目的地')">
              目的地：
              <input type="text" v-model="cardrop.destination" readonly placeholder="请输入目的地" class="input_long">
            </van-col>
            <van-col span="10"> 
              航站楼 <input v-model="cardrop.terminal" type="text" placeholder="航站楼" class="input_short">
            </van-col>
          </van-row>

          <van-row type="flex" class="input_margin">
            <!-- @click="$refs.picker.toggle()"  -->
            <van-col>
              用车时间：<input v-model="cardrop.useTime" readonly type="text" placeholder="请选择用车时间" class="input_short_bott">
            </van-col>
          </van-row>
          <van-row type="flex" class="input_margin">
            <van-col span="14"> 
              选择车型:<input @click="Selectcar()" readonly type="text" v-model="cardropmodels.vehicleTypeName" placeholder="请选择车型" class="input_long">
            </van-col>
            <van-col span="10" style="display: flex;" > 
                 
              车数量:
              <!-- <input v-model="cardrop.carnumber"  @input="carvehicles(cardrop.carnumber)"   type="text" placeholder="车数量" class="input_short"> -->
              <van-stepper v-model="cardrop.carnumber" @change="carvehicles(cardrop.carnumber)" button-size="22" disable-input />
            </van-col>
          </van-row>
        </van-tab>
      </van-tabs>
    </van-cell>
    <!--选择时间事件-->
    <ld-date-picker
      ref="picker"
      @confirm="selectDate"
    />
    <van-popup v-model="popupshow" position="right" :style="{ width: '100%', height: '100%' }">
      <!-- 城市选择组件 -->
      <!-- //cityName 城市名字
              //cityId 城市ID -->
      <!-- showSite可能控制城市页面的打开 -->
      <!--carType也传具体传什么看看  -->
      <!-- callBack标题左侧事件 -->
      <!-- selected 点击城市信息给传过来 -->
      <!-- :back-true="backTrue" -->
      <ht-search
        ref="htsearch"
        :car-type="carType"
        :city-id.sync="cityId"
        :city-name.sync="cityName" 
        :jcZdCode.sync="jcZdCode"
        :is-car="true"
        placeholder="请输入关键字"
        :show-site = "showSite"
        @selected="jsycSite"
        @callBack="hideSite"
        :back-true="backTrue"
      />
    </van-popup>
    <van-popup v-model="carpopupshow" position="right" :style="{ width: '100%', height: '100%' }">
      <car-listcom 
        ref="carlistcom"
        :carlistdata="carlistdata"
        @carchecklist="carchecklist"
        @onClickRight="carpopupshow=!carpopupshow"
      />
    </van-popup>

  </div>
</template>

<script>
import {Cell, Checkbox, CheckboxGroup, Dialog,   Tag,Collapse, CollapseItem,ContactCard,
  Button, 
  Tab, 
  Tabs,
  CellGroup ,
  Field,
  Popup,
  Stepper,

} from 'vant'
import ldDatePicker from 'Common/ldDatePicker'
import htSearch from 'Views/Ht/htQuery/htSearch/index.vue' //选择城市组件
import CarListcom from './carlistcom'  //选择车类型组件
import { mapGetters } from 'vuex'
import { CONSOLE_MONITOR_ENABLE } from '@/business/config'
export default {
  name: 'transferInfo',
  components: {
    [Cell.name]: Cell,
    [Button.name]: Button ,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    ldDatePicker,
    htSearch,
    CarListcom,
    [Popup.name]: Popup,
    [Stepper.name]:Stepper,
  },
  props: {
    flights:{
      type: [Object,Array],
    } 
  },
  data(){
    return {
      active: '',
      lian:'联',
      filltitle:false,
      popupshow:false,//弹窗是否显示
      carpopupshow:false,
      backTrue:0,
      carlistdata:'',//给列表传参数
      jcZdCode:'',//机场三字码
      //接机给个默认的出发地
      carpick:{//接机
        departure_place:`${this.flights[0].arriveCityName}${this.flights[0].arriveAirportName}`,//出发地
        terminal:this.flights[0].arriveTerminal, //航站楼
        destination:'',//目的地，
        arriveCity:this.flights[0].arriveCity,//用车城市id
        departCity:this.flights[0].arriveCity,//到达城市id
        flightNo:this.flights[0].flightNo,//航班号
        useAirportOrZd:this.flights[0].arriveAirport, //机场三字码
        fromAddress:'',//出发地详细地址
        fromLat:'',//出发地纬度
        fromLocationName:this.flights[0].arriveAirportName,//出发地名称
        fromLon:'',//出发地经度
        toAddress:'',//目的地详细地址
        toLat:'',//目的地纬度
        toLocationName:'',//目的地名称
        toLon:'',//目的地经度
        useTime:`${this.flights[0].arriveDate} ${this.flights[0].arriveTime}`,//用车时间
        // useType =4接机  5送机
        useType:4,//用车类型
        vehicleTypeId:'',//车型id
        carnumber:1, ////车数量
               
      },
      cardrop:{//送机
        destination:`${this.flights[0].departCityName}${this.flights[0].departAirportName}`, //目的地，
        terminal:this.flights[0].departTerminal,
        flightNo:this.flights[0].flightNo,//航班号
        arriveCity:this.flights[0].departCity,//用车城市
        departCity:this.flights[0].departCity,//到达城市
        useAirportOrZd:this.flights[0].departAirport,//机场三字码
        fromAddress:'',//出发地详细地址
        fromLat:'',//出发地纬度
        fromLocationName:'',//出发地名称
        fromLon:'',//出发地经度
        toAddress:'',//目的地详细地址
        toLat:'',//目的地纬度
        toLocationName:this.flights[0].departAirportName,//目的地名称
        toLon:'',//目的地经度
        useTime:`${this.flights[0].departDate} ${this.flights[0].departTime}`,//用车时间
        // useType =4接机  5送机
        useType:5,//用车类型
        vehicleTypeId:'',//车型id
        carnumber:1, //车数量
               
      },
      carpickmodels:'', //接机车型
      cardropmodels:'', //送机车型
      cityName:'',//城市名称 
      cityId:'',//城市id
      showSite:false,//显示的城市
      carType:0,
      // location:['','出发地','目的地']
      location:'',
      dropdisable:false,//送机禁用
      pickupdisable:false,//接机禁用
    }
  },
  computed:{
    ...mapGetters({
      sysType:'sysType', //订单来源
      travelerList: 'tk/travelerList',
    }),
  },
  methods:{
    selectDate(date, index) {//选择时间回调事件
      if(this.active==0){
        this.carpick.useTime= `${date.date} ${date.hm}`
      }else{
        this.cardrop.useTime= `${date.date} ${date.hm}`
      }
    },
    fillshow(){//是否显示填写信息
      this.filltitle = !this.filltitle;
      this.$emit('fillshow',this.filltitle)
    },
    
    cityselect(item){ //选择城市事件
      this.location=item
      if(this.active==0){//接机
        this.cityName=this.flights[0].arriveCityName//传入城市名称 
        this.cityId=this.flights[0].arriveCity //传入城市id
        this.jcZdCode=this.flights[0].arriveAirport //传入城市机场三字码
      }else{//送机
        this.cityName=this.flights[0].departCityName
        this.cityId=this.flights[0].departCity
        this.jcZdCode=this.flights[0].departAirport 
      }
      //打开城市对应传入城市列表
      let parameters={
        cityName:this.cityName,
        keywords:this.cityName,
        count:10
      }
      this.$nextTick(()=>{
        this.$refs.htsearch.baiduSelect(parameters)
      })
      this.popupshow=true
    },
    hideSite(){//城市组件关闭回退
      this.popupshow=false
    },
    jsycSite(item,para){//选择城市信息的回调
      //cityId城市id
      console.log('123456',para,item)
      this.popupshow=false
      let airport = this.active == 0 ? 'carpick' : 'cardrop';
      if(this.location=='出发地'){
        this[airport].fromAddress=item.address
        this[airport].fromLat=item.location.lat
        this[airport].fromLocationName=item.name
        this[airport].fromLon=item.location.lng
        this[airport].departCity=para.cityId
        if(this.active==0){//接现的出发，出现变动
          this[airport].departure_place=item.name
          this[airport].useAirportOrZd=para.jcZdCode
        }
      }else{//目的地
        this[airport].toAddress=item.address
        this[airport].toLat=item.location.lat
        this[airport].toLocationName=item.name
        this[airport].toLon=item.location.lng
        this[airport].arriveCity=para.cityId
        if(this.active==1){
          this[airport].destination=item.name
          this[airport].useAirportOrZd=para.jcZdCode //动态增加三字码
        }
        //  this[airport].departCity=item.siteCityId
      }
           
      console.log('调市回调信息',item)
    },
    async Selectcar(){//选择车型打开
      // consoel.log("123456")
      //需要在这里判断一下接机的出发地，送机的目的地，是否有更改
      //未更改的处理方式
      if(this.active==0){//接机
        if(this.carpick.fromLocationName && this.carpick.toLocationName && this.carpick.useTime){
          if(this.carpick.departure_place==`${this.flights[0].arriveCityName}${this.flights[0].arriveAirportName}`){
            let res=  await this.getLatlng(this.flights[0].arriveCityName,this.flights[0].arriveAirportName)
            this.carpick.fromAddress=res.address
            this.carpick.fromLat=res.location.lat
            this.carpick.fromLon=res.location.lng
          }
        }else{
          return this.$toast('请先完善送机信息')
        }
    
      }else{//送机
        if(this.cardrop.fromLocationName=='' || this.cardrop.destination==''  ||  this.carpick.useTime=='' ){
          return this.$toast('请先完善送机信息')
        }
        if(this.cardrop.destination== `${this.flights[0].departCityName}${this.flights[0].departAirportName}`){
          //代表没有动送机的目的地
          let res=  await this.getLatlng(this.flights[0].departCityName,this.flights[0].departAirportName)
          this.cardrop.toAddress=res.address
          this.cardrop.toLat=res.location.lat
          this.cardrop.toLon=res.location.lng
          this.cardrop.toLocationName
        }
      }
      this.carlistdata= this.active==0 ? this.carpick : this.cardrop
      this.carpopupshow = true //打开弹窗
      this.$nextTick(()=>{
        this.$refs.carlistcom.carlist(this.carlistdata)
      })
    },
    async getLatlng(cityName, keywords) {// 关键字 获取经纬度
      let {data = {}} = await this.$api['city/baiduPlace']({
        cityName: cityName,
        keywords: keywords
      })
      data.list = data.list || []
      if (data == {}) {
        this.$toast('查询失败')
        return false
      }
      let dataList = data.list.find(i => i.location)
      if (cityName == '重庆') {
        dataList = data.list.find(i => i.name == '重庆江北国际机场')
      }
      return dataList
    },
    carchecklist(info,item,cacheId){//选择车型完毕业
      //info选中的那条数据，item全部数据
      if(this.active==0){
        this.carpick.productId=info.productId
        this.carpick.cacheId=cacheId
        item.salePrice=info.salePrice //选中的车型价格，给全部
        this.carpickmodels=item
      }else{
        this.cardrop.productId=info.productId
        this.cardrop.cacheId=cacheId
        this.cardropmodels=item
      }
      this.carpopupshow=false //关闭弹窗
      //在这里往vuex中存接机、送机数据
      this.$emit("carnumber",info,this.active)
      this.$emit("picksenddaea",this.carpick,this.cardrop)
      let numberp
      this.active==0 ?numberp=this.carpick.carnumber:numberp=this.cardrop.carnumber
      this.$emit('carnumber',numberp,this.active)//传数量
    },
    carvehicles(item){//选择用车数量
      this.$emit('carnumber',item,this.active) //传数量
      this.$emit("picksenddaea",this.carpick,this.cardrop)
    },
    carnumbershow(number){
      if(this.travelerList.length == number){
        return true
      }
      if(this.travelerList.length > number){
        return false
      }
      if(this.travelerList.length < number){
        return true
      }
    }
  },
  watch:{
    carpick:{
      handler(newValue) {
        this.$store.commit("tk/tkcarpick",newValue)
      },
      immediate:true,
      deep:true
    },
    cardrop:{
      handler(newValue) {
        this.$store.commit("tk/tkcardrop",newValue)
      },
      immediate:true,
      deep:true
    }
  }
}
</script>

<style scoped lang="less">
@import '~Assets/styles/business';
.transfbox{
    display: flex;
    align-items: center;
}
.transfbox .trans_fillin{
    background-color: #169BD5;
    height: 21px;
    width: 86px;
    font-size: 12px;
    color: #fff;
    display: flex;
    justify-content: center;
    border-radius: 5%;
    margin-left: 6px;
    align-items: center;
}
.input_long{
    // height: 3vh;
    //  width: 31vw;
    height:0.435rem;
    width: 2.4rem;
   
    font-size: 12px;
}
.input_short{
    // height: 3vh; 
    // width: 21vw;
    height:0.435rem;  
    width: 1.4rem;
    
    font-size:12px
}
.input_short_bott{
    // width: 31vw;
    // height: 3vh;   
    height:0.435rem;
    width: 2.4rem;
    font-size: 12px
}
.input_margin{
    margin-top: 1.8vh;
}

</style>